module.exports = __webpack_public_path__ + "static/media/phone-group-2.135c5a6a.png";